import { useEffect, useState } from "react"

/**
 * Whether the current device can hover, that is, it has a mouse or trackpad
 * rather than a touch screen. Used to suppress hover-only affordances such as
 * tooltips on touch devices. Starts optimistic (true) so the first
 * server/client render matches, then corrects on mount.
 */
export function useHoverCapable(): boolean {
  const [canHover, setCanHover] = useState(true)

  useEffect(() => {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
      return
    }
    const query = window.matchMedia("(hover: hover)")
    const update = () => setCanHover(query.matches)
    update()
    query.addEventListener("change", update)
    return () => query.removeEventListener("change", update)
  }, [])

  return canHover
}
